__turbopack_context__.v({
  "Separator": "_9SfxtG_Separator",
  "connectButton": "_9SfxtG_connectButton",
  "currentProjectBadge": "_9SfxtG_currentProjectBadge",
  "details": "_9SfxtG_details",
  "editBtn": "_9SfxtG_editBtn",
  "emptyData": "_9SfxtG_emptyData",
  "expItem": "_9SfxtG_expItem",
  "label": "_9SfxtG_label",
  "list": "_9SfxtG_list",
  "logo": "_9SfxtG_logo",
  "primaryLabel": "_9SfxtG_primaryLabel",
  "root": "_9SfxtG_root",
  "row": "_9SfxtG_row",
  "secondaryLabel": "_9SfxtG_secondaryLabel",
});
